<template>
  <div class="layout reference-clients">
    <div class="reference-clients-title">Клиенты</div>
    <div class="reference-clients-filters">
      <div class="reference-clients-filters-fields">
        <c-input
          v-model="filters.customerType"
          class="reference-clients-filters-fields-type"
          label="Тип клиента"
          type="select"
          :clearable="true"
          :items="filters.customerTypeItems"
          placeholder="Все"
        />
        <c-input
          v-model="filters.search"
          class="reference-clients-filters-fields-search-text"
          placeholder-style="italic"
          icon="search"
          type="text"
          :clearable="true"
          placeholder="Поиск по ФИО, телефону, email"
        />
      </div>
      <div class="reference-clients-filters-buttons">
        <c-button
          class="reference-clients-filters-buttons-apply"
          label="Применить"
          color="primary"
          @click="applyFilters"
        />
        <c-button class="reference-clients-filters-buttons-reset" label="Сбросить" @click="resetFilters" />
      </div>
    </div>
    <div v-if="!isTableLoading" class="reference-clients-table">
      <c-data-table-reference-clients
        ref="tableReferenceClients"
        class="reference-clients-table-table"
        :sorted-column="tableData.sortedColumn"
        :levels="1"
        :empty-records-label="'Записи не найдены'"
        :disabled-columns="[]"
        :data="tableData"
        @sortedEvent="refreshTable"
      />
      <c-loader v-if="isLoadingData" label="Загрузка данных" :active="isLoadingData" height="150" />
    </div>
    <c-loader
      v-if="isTableLoading"
      class="reference-clients-loader"
      label="Загрузка списка клиентов"
      :active="isTableLoading"
      height="500"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";

import Button from "@/components/controls2/Button";
import Input from "@/components/controls2/Input";
import Loader from "@/components/loader";

import ReferenceClientsDataTable from "@/pages/reference-clients/reference-clients-data-table";

export default {
  name: "reference-clients",

  components: {
    "c-button": Button,
    "c-input": Input,
    "c-loader": Loader,
    "c-data-table-reference-clients": ReferenceClientsDataTable,
  },

  data() {
    return {
      isTableLoading: false,
      isLoadingData: false,
      isDisabledScrollDataLoading: false,
      filters: {
        customerType: null,
        customerTypeItems: [
          { label: "Сотрудники", value: "worker" },
          { label: "Клиенты", value: "client" },
        ],
        search: this.$route.query.search ? this.$route.query.search : "",
      },
      periodLocal: null,
      tableData: {
        type: "reference-clients",
        sortedColumn: {
          sortBy: this.$route.query.sortBy ? this.$route.query.sortBy : "created",
          sortType: this.$route.query.sortType ? this.$route.query.sortType : "desc",
        },
        columns: [],
        records: [],
        actions: true,
        enabledFields: [],
        levels: [],
        filteredColumns: [],
        activeFilteredColumns: [],
        globalFilters: {
          customerType: this.$route.query.customerType ? this.$route.query.customerType : "",
          search: this.$route.query.search ? this.$route.query.search : "",
        },
      },
      page: 1,
    };
  },

  computed: {
    ...mapGetters("referenceClients", ["getTableColumns", "getTableRecords"]),
  },

  watch: {
    "getTableRecords": function (value) {
      if ((value === undefined || (Array.isArray(value) && value.length === 0)) && this.page === 1) {
        this.tableData.records = [];
        this.isDisabledScrollDataLoading = true;
        return;
      }

      if ((value === undefined || (Array.isArray(value) && value.length === 0)) && this.page !== 1) {
        this.isDisabledScrollDataLoading = true;
        return;
      }

      const currentPageRecords = value.map((record) => ({
        customerId: record.customer_id,
        isWorker: record.is_worker,
        created: {
          value: record.created !== null ? moment(record.created).format("DD.MM.YYYY") : undefined,
        },
        name: {
          value: record.name,
        },
        phone: {
          value: record.phone,
        },
        email: {
          value: record.email,
        },
        orders_count: {
          value: record.orders_count,
        },
        isShowRow: true,
      }));

      if (this.page === 1) {
        this.tableData.records = [...currentPageRecords];
      } else {
        this.tableData.records = this.tableData.records.concat(currentPageRecords);
      }
    },

    "tableData.globalFilters": {
      deep: true,
      handler() {
        this.refreshTable({
          sortBy: this.tableData.sortedColumn.sortBy,
          sortType: this.tableData.sortedColumn.sortType,
        });
      },
    },
  },

  mounted() {
    const columns = this.getTableColumns.map((col) => {
      col.isSorted = col.id === this.tableData.sortedColumn.sortBy;
      return col;
    });
    this.tableData.columns = [...columns];
    document.querySelector(".layout").addEventListener("scroll", this.loadMoreRecords);
    window.addEventListener("keyup", (event) => {
      if (event.keyCode === 13) {
        this.applyFilters();
      }
    });

    if (this.$route.query.customerType) {
      this.filters.customerType =
        this.$route.query.customerType === "worker"
          ? { label: "Сотрудники", value: "worker" }
          : { label: "Клиенты", value: "client" };
    }
  },

  async created() {
    this.isTableLoading = true;

    await this.$store
      .dispatch("referenceClients/getIikoCustomersList", {
        page: this.page,
        sortBy: this.tableData.sortedColumn.sortBy,
        sortType: this.tableData.sortedColumn.sortType,
        customerType: this.filters.customerType !== null ? this.filters.customerType.value : "",
        search: this.filters.search,
      })
      .then(() => {
        setTimeout(() => {
          this.isTableLoading = false;
        }, 800);
        setTimeout(() => {
          this.$refs.tableReferenceClients.updatePositionTop();
        }, 1000);
      });
  },

  methods: {
    applyFilters() {
      this.tableData.globalFilters.customerType =
        this.filters.customerType !== null ? this.filters.customerType.value : "";
      this.tableData.globalFilters.search = this.filters.search;
    },

    resetFilters() {
      this.tableData.globalFilters.customerType = "";
      this.tableData.globalFilters.search = "";
      this.filters.search = "";
      this.filters.customerType = null;
    },

    loadMoreRecords() {
      const layout = document.querySelector(".layout");
      const isScrollable = layout.scrollHeight > layout.clientHeight;

      const scroll = Math.round(layout.scrollTop);
      const height = layout.scrollHeight - layout.clientHeight;

      if (
        isScrollable &&
        scroll === height &&
        !this.isTableLoading &&
        !this.isLoadingData &&
        !this.isDisabledScrollDataLoading
      ) {
        this.isLoadingData = true;
        this.page += 1;
        this.$store
          .dispatch("referenceClients/getIikoCustomersList", {
            page: this.page,
            sortBy: this.tableData.sortedColumn.sortBy,
            sortType: this.tableData.sortedColumn.sortType,
            customerType: this.tableData.globalFilters.customerType,
            search: this.tableData.globalFilters.search,
          })
          .finally(() =>
            setTimeout(() => {
              this.isLoadingData = false;
            }, 300),
          );
      }
    },

    refreshTable(e) {
      if (!this.isTableLoading) {
        this.isTableLoading = true;
        this.isDisabledScrollDataLoading = true;
        this.page = 1;

        const { customerType } = this.tableData.globalFilters;
        const { search } = this.tableData.globalFilters;
        const queryFilters = {
          ...(search === "" ? null : { search }),
          ...(customerType === "" ? null : { customerType }),
        };

        this.$store
          .dispatch("referenceClients/getIikoCustomersList", {
            page: this.page,
            sortBy: e.sortBy,
            sortType: e.sortType,
            customerType: this.tableData.globalFilters.customerType,
            search: this.tableData.globalFilters.search,
          })
          .then((res) => {
            if (res.response !== undefined && res.response.length === 30) {
              this.isDisabledScrollDataLoading = false;
            }
            this.$router
              .replace({
                name: "reference-clients",
                query: {
                  sortBy: e.sortBy,
                  sortType: e.sortType,
                  ...queryFilters,
                },
              })
              .catch(() => {});
          })
          .finally(() =>
            setTimeout(() => {
              this.isTableLoading = false;
            }, 300),
          );
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.reference-clients {
  padding: 33px 30px 30px 30px;
  position: relative;

  @media screen and (max-width: 1000px) {
    padding: 33px 30px 30px 30px;
  }

  @media screen and (max-width: 700px) {
    padding: 20px;
  }

  &-title {
    font-weight: 500;
    font-size: 22px;
    line-height: 108%;
  }

  &-filters {
    margin-top: 27px;
    display: flex;
    align-items: flex-end;

    @media screen and (max-width: 1200px) {
      flex-direction: column;
    }

    &-fields {
      display: flex;
      max-width: 565px;
      width: 100%;
      align-items: flex-end;

      @media screen and (max-width: 1200px) {
        max-width: 907px;
        margin-right: auto;
        width: 100%;
      }

      @media screen and (max-width: 700px) {
        flex-direction: column;
      }

      &-type {
        width: 100%;
        max-width: 168px;

        @media screen and (max-width: 1200px) {
          max-width: 22%;
        }

        @media screen and (max-width: 700px) {
          max-width: 100%;
        }
      }

      &-search-text {
        width: 100%;
        max-width: 367px;
        margin-left: 30px;

        @media screen and (max-width: 1200px) {
          max-width: 74%;
        }

        @media screen and (max-width: 700px) {
          margin: 23px 0 0 0;
          width: 100%;
          max-width: 100%;
        }
      }
    }

    &-buttons {
      display: flex;
      align-items: flex-end;
      margin-left: 30px;

      @media screen and (max-width: 1200px) {
        margin: 31px 0 0 0;
        width: 100%;
      }

      &-apply {
        max-width: 130px;

        @media screen and (max-width: 700px) {
          max-width: calc(50% - 7.5px);
          width: calc(50% - 7.5px);
          order: 2;
          margin-left: 10px;
        }
      }

      &-reset {
        max-width: 120px;
        margin-left: 10px;

        @media screen and (max-width: 700px) {
          margin-left: 0;
          max-width: calc(50% - 7.5px);
          width: calc(50% - 7.5px);
          order: 1;
        }
      }
    }
  }

  &-table {
    position: relative;
    max-width: 907px;
    margin-top: 33px;

    &-table {
      width: 100%;
      max-width: 907px;

      @media screen and (max-width: 700px) {
        width: calc(100% + 40px);
        max-width: calc(100% + 40px);
      }
    }
  }

  &-loader {
    margin-top: 33px;
  }
}

::v-deep .c-table__wrapper > .ps__rail-x {
  z-index: 351;
  background: #ffffff !important;
}

::v-deep .c-table__wrapper > .ps__rail-x:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-30px, 0);
  box-shadow: 0px 0px 15px rgba(0, 21, 80, 0.3);
  z-index: -1;
  height: 24px;
  width: calc(100vw - 60px);
  background: #ffffff;
}

::v-deep .c-table__wrapper > .ps__rail-x:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, calc(-50% + 1px));
  border-radius: 10px;
  z-index: -1;
  height: 4px;
  width: calc(100% - 34px);
  background: #dfe4ef;
}
</style>
